export interface Library {
	tenantName: string;
	tenantId: string;
	isAutodeskManagedLibrary: boolean;
	canShareTemplateExternally: boolean;
}

export interface GetLibraryListResponse {
	superAdminAllowedLibraries: Library[];
	publicLibraries: Library[];
}

export interface LibraryStoreState {
	superAdminAllowedLibraries: Library[];
	publicLibraries: Library[];
	initialized: boolean;
}
